import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { addContentFavorite, removeContentFavorite } from '../../actions/spaces/FavoritesActions';
import { NavLocationSelectors } from '../../selectors/NavigationStateSelectors';
import { SessionServerSelectors } from '../../selectors/SessionInfoSelectors';
import { AppState } from '../../state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../utils/ConnectUtils';
import { ListView, ListViewDispatchProps, ListViewOwnProps, ListViewStateProps } from './ListView';

const mapStateToProps: MapStateToProps<ListViewStateProps> = (state: AppState) => ({
  displaySchedulesInClientTimezone: SessionServerSelectors.displaySchedulesInClientTimezone(state),
  ignoreExtractTaskPriority: SessionServerSelectors.ignoreExtractTaskPriority(state),
  displayScheduleDescriptionAsName: SessionServerSelectors.displayScheduleDescriptionAsName(state),
  inServerArea: NavLocationSelectors.inServerArea(state),
});

const mapDispatchToProps: MapDispatchToProps<ListViewDispatchProps> = (dispatch) => bindActionCreators({
  addContentFavorite: addContentFavorite,
  removeContentFavorite: removeContentFavorite,
}, dispatch);

export const ConnectedListView: React.ComponentClass<ListViewOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(ListView);
